import { gql } from '@apollo/client';
import Create from './Create';
import List from './List';
import Show from './Show';

export default {
  name: 'reverse_invoice_files',
  inputShow: gql`
    query reverseInvoiceFiles($input: ReverseInvoiceFileQueryInput) {
      reverseInvoiceFiles(input: $input) {
        id
        __typename
      }
    }
  `,
  create: Create,
  list: List,
  show: Show,
  options: {
    group: 'Billing',
    label: 'Reverse Invoices',
  },
};
